import { render, staticRenderFns } from "./Founding.vue?vue&type=template&id=3d34b22a&"
import script from "./Founding.vue?vue&type=script&lang=js&"
export * from "./Founding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports